import DynamicComponent from "./DynamicComponent";
import type { GlobalComponentContent, SBComponents } from "./DynamicComponent.d";
import { renderDynamicComponent } from "./DynamicComponent.utils";

export { DynamicComponent, renderDynamicComponent };
export type { GlobalComponentContent, SBComponents };
